module.exports = __webpack_public_path__ + "img/instrumenty-2.6f4c3c5b.jpg";